import { Checkbox, Radio } from '@mui/material';
import { useGetCCAssets } from 'src/hooks';

import { ProductListModalCheckboxProps } from '../ProductListModal.interface';
import { ProductListModalFormControlLabel } from '../ProductListModal.styled';
import { CustomProductLabel } from './CustomProductLabel';

export const ProductListModalCheckboxes = (
  props: ProductListModalCheckboxProps,
) => {
  const { data: assets = [] } = useGetCCAssets();

  return (
    <ProductListModalFormControlLabel
      disableTypography
      control={
        props.singleSelectionMode ? (
          <Radio
            inputProps={
              {
                'data-testid': `product-list-modal-radio-${props.product.product_code}`,
              } as any
            }
            disableRipple
            value={props.product.product_code}
            onChange={() => props.onCheckToggle(props.product)}
            checked={props.checked && !props.disabled}
          />
        ) : (
          <Checkbox
            inputProps={
              {
                'data-testid': `product-list-modal-checkbox-${props.product.product_code}`,
              } as any
            }
            disableRipple
            value={props.product.product_code}
            onChange={() => props.onCheckToggle(props.product)}
            checked={props.checked && !props.disabled}
          />
        )
      }
      label={
        <CustomProductLabel
          product={props.product}
          assets={assets}
          inputValue={props.inputValue}
          productVariationTypes={props.productVariationTypes}
          productVariationFlavors={props.productVariationFlavors}
        />
      }
    />
  );
};
